export default function(fetch, siteId, module, method = 'findOptions') {
  return searchStr =>
    fetch(`/${siteId}/graphql`, {
      body: JSON.stringify({
        query: `{
          ${module} {
            ${method}(startsWith: ${JSON.stringify(
          searchStr,
        )}) { label value data }
          }
        }`,
      }),
    })
      .then(response => response.json())
      .then(json => {
        const options = ((json.data || {})[module] || {})[method];
        if (!options) {
          throw new Error('findOptions error occurred.');
        }
        return options;
      });
}

export function getOptionsWithDataFilter(
  fetch,
  siteId,
  module,
  method = 'findOptions',
  data = null,
) {
  return searchStr =>
    fetch(`/${siteId}/graphql`, {
      body: JSON.stringify({
        query: `{
          ${module} {
            ${method}(startsWith: ${JSON.stringify(
          searchStr,
        )}, data: ${JSON.stringify(data)}) { label value data }
          }
        }`,
      }),
    })
      .then(response => response.json())
      .then(json => {
        const options = ((json.data || {})[module] || {})[method];
        if (!options) {
          throw new Error('findOptions error occurred.');
        }
        return options;
      });
}



// WEBPACK FOOTER //
// ./src/data/fetch/getOptions.js